exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-notice-wrapper {\n  top: 50px !important;\n}\n", ""]);

// exports
